import { useAuth0 } from "@auth0/auth0-react";

export default function AuthErrorHandler({ children }) {
  const {
    error,
    isLoading,
    loginWithRedirect,
  } = useAuth0();

  if (isLoading) {
    return null;
  }

  if (error) {
    const description =
      error?.error_description ||
      error?.message ||
      "";

    const emailNotVerified =
      error?.error === "access_denied" &&
      description.includes(
        "EMAIL_NOT_VERIFIED"
      );

    if (emailNotVerified) {
      return (
        <section className="auth-page">
          <div className="auth-container">
            <h2>Potwierdź swój e-mail</h2>

            <p>
              Wysłaliśmy Ci wiadomość z linkiem
              aktywacyjnym. Kliknij link w wiadomości,
              a następnie zaloguj się ponownie.
            </p>

            <button
              onClick={() =>
                loginWithRedirect({
                  appState: {
                    returnTo: "/profile",
                  },
                  authorizationParams: {
                    audience:
                      "https://someet-api",
                  },
                })
              }
            >
              Zaloguj się ponownie
            </button>
          </div>
        </section>
      );
    }

    return (
      <section className="auth-page">
        <div className="auth-container">
          <h2>Nie udało się zalogować</h2>
          <p>{description}</p>
        </div>
      </section>
    );
  }

  return children;
}